let Handlebars = require('handlebars');

module.exports = function (value) {
    return new Handlebars.SafeString((value || "").toLowerCase());
};


// WEBPACK FOOTER //
// ./src/hbHelpers/toLowerCase.js